function capitalizeWord(str: null | undefined): null | undefined;
function capitalizeWord(str: string): string;
function capitalizeWord(str: Maybe<string>): Maybe<string> {
  return str ? `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}` : str;
}

export { capitalizeWord };

export const stripUrlProtocol = (url: string) => url.replace(/(^\w+:|^)\/\//, '');

const slugify = (title: string): string =>
  title
    .toLowerCase()
    .trim()
    .replace(/[\s]+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+|-+$/g, '');

// Diacritics are stripped only when the plain pass is empty, so existing slugs never change.
export const generateSlugFromTitle = (title: string): string => slugify(title) || slugify(title.normalize('NFKD').replace(/\p{M}/gu, ''));

export const FALLBACK_PAGE_SLUG = 'page';

// Scripts with no ASCII form (Japanese, Arabic, ...) still need an address the server accepts.
export const generateSlugFromTitleOrDefault = (title: string): string => generateSlugFromTitle(title) || FALLBACK_PAGE_SLUG;

export const hasLetterOrNumber = (title: string): boolean => /[\p{L}\p{N}]/u.test(title);

export const formatCamelCase = (str: string): string => {
  // Split on capital letters and trim any extra spaces
  const words = str.replace(/([A-Z])/g, ' $1').trim();
  // Capitalize first letter of the entire string
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const charCodeOfLetterA = 'A'.charCodeAt(0);

/**
 * 0 → A, 1 → B, ... 25 → Z, 26 → AA, 27 → AB, ... 702 → AAA ...
 */
export const indexToLetter = (n: number): string => {
  if (!Number.isInteger(n) || n < 0) {
    throw new Error('n must be a non-negative integer');
  }

  let x = n + 1;
  let out = '';

  while (x > 0) {
    x -= 1;
    out = String.fromCharCode(charCodeOfLetterA + (x % 26)) + out;
    x = Math.floor(x / 26);
  }

  return out;
};
